import React from 'react';

import { startConflictDays, startConflictMessage, startIsClear } from './dependencies/earliestStart';

import { formatDateLong } from 'Helpers/dateFormat';

import TextButton from 'CommonComponents/TextButton';

import WarningTriangleIcon from 'Assets/icons/warning-triangle.svg';

/** Where the activity's start stands against the earliest start its predecessors allow. */
const ActivityEarliestStartLine = ({ earliestStartDate, startDate, isComplete, canMoveStart, canMoveStartBy, onMoveStart }) => {
    if (!earliestStartDate) {
        return <div className="tw-text-sm tw-text-charcoal-60">{$t('No predecessors. This activity can start any time.')}</div>;
    }

    const date = formatDateLong(earliestStartDate);

    if (startIsClear(startDate, earliestStartDate, isComplete)) {
        return <div className="tw-text-sm tw-text-dark-green">{$t('Predecessors allow a start from {{date}}', { date })}</div>;
    }

    const conflictDays = startConflictDays(startDate, earliestStartDate);

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-text-sm">
            <span className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-amber-700">
                <WarningTriangleIcon className="tw-h-4 tw-w-4 tw-shrink-0 tw-text-amber-500" aria-hidden="true" />
                {startConflictMessage(conflictDays, earliestStartDate)}
            </span>
            {!!canMoveStart && (!canMoveStartBy || canMoveStartBy(conflictDays)) && (
                <TextButton variant="primary" onClick={() => onMoveStart(conflictDays)}>
                    {$t('Move start to {{date}}', { date })}
                </TextButton>
            )}
        </div>
    );
};

export default ActivityEarliestStartLine;
